interface StepSelectorProps {
  title: string;
  description?: string | null;
  value: string | null;
  options: string[];
  onChange: (val: string) => void;
  placeholder: string;
  disabled?: boolean;
}

export default function StepSelector({
  title,
  description,
  value,
  options = [],
  onChange,
  placeholder,
  disabled,
}: StepSelectorProps) {
  return (
    <div className="step">
      <p className="step-title">{title}</p>
      {description && <p className="step-description">{description}</p>}{' '}
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
}
